import React, { useEffect } from "react";
import { Box, Flex, Heading, Pagination } from "@catchoftheday/cg-components";
import { useUpdateDataLayer, useUpdateEcommerceData } from "@search-app/analytics";
import { ProductGrid } from "@search-app/components/ProductGrid";
import { SEARCH_URL_PARAM_PAGE } from "@search-app/helpers/search/search.helpers.params";
import { useShallowSelector } from "@search-app/store";
import { hasFacets, isInitialSearch, isSearchLoading, pageCurrent, pageTotal, searchResults } from "@search-app/store/search/selectors";
import { routeToQueryParam } from "@search-app/utilities/router";
import scrollTop from "@search-app/utilities/scrollTop.utilities";
import { ResultsPlaceholder } from "./ResultsPlaceholder";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var Results = function Results() {
  useUpdateAnalytics();

  var _useReduxState = useReduxState(),
      isInitialSearch = _useReduxState.isInitialSearch,
      hasFacets = _useReduxState.hasFacets,
      searchResults = _useReduxState.searchResults,
      isLoading = _useReduxState.isLoading,
      pageCurrent = _useReduxState.pageCurrent,
      pageTotal = _useReduxState.pageTotal;

  useEffect(function () {
    var _window$cotd;

    if (true && (_window$cotd = window.cotd) !== null && _window$cotd !== void 0 && _window$cotd.isMobileWeb && window.scrollY !== 0 && searchResults.length < 9) {
      window.scrollTo(0, 0);
    }
  }, [searchResults]);

  if (isInitialSearch) {
    return ___EmotionJSX(Flex, {
      flexGrow: 1,
      flexWrap: "wrap"
    }, ___EmotionJSX(ResultsPlaceholder, null));
  }

  if (!searchResults.length) {
    return null;
  }

  return ___EmotionJSX(Box, {
    as: "article",
    mb: "20px",
    width: "100%"
  }, !hasFacets && ___EmotionJSX(Heading.h2, {
    ml: "10px",
    fontSize: {
      xs: "1.14rem",
      md: "1.43rem",
      lg: "1.714rem"
    }
  }, "Have a look at our top sellers"), ___EmotionJSX(Box, {
    as: "section"
  }, ___EmotionJSX(ProductGrid, {
    lazyLoad: true,
    productItems: searchResults
  })), typeof pageCurrent === "number" && typeof pageTotal === "number" && true ? ___EmotionJSX(Flex, {
    justifyContent: "center"
  }, ___EmotionJSX(Pagination, {
    isDisabled: isLoading,
    onPageClick: function onPageClick(page) {
      routeToQueryParam([{
        key: "page",
        value: page
      }]);
      scrollTop();
    },
    urlPath: window.location.href,
    pageCurrent: pageCurrent,
    pageTotal: pageTotal,
    parameter: SEARCH_URL_PARAM_PAGE,
    fontSize: [10, 12, 14]
  })) : null);
};

var useReduxState = function useReduxState() {
  return useShallowSelector(function (state) {
    return {
      isInitialSearch: isInitialSearch(state),
      isLoading: isSearchLoading(state),
      pageCurrent: pageCurrent(state),
      pageTotal: pageTotal(state),
      hasFacets: hasFacets(state),
      searchResults: searchResults(state)
    };
  });
};

var useUpdateAnalytics = function useUpdateAnalytics() {
  useUpdateDataLayer();
  useUpdateEcommerceData();
};